export default {
  scenes: {
    countdownBegins: {
      beats: {
        nyxUltimatum: {
          events: [
            {
              type: 'showLocation',
              locationId: 'commandCenter'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We need to find the weapon\'s control system and disable it before it\'s too late.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We\'re running out of time, Captain. Let\'s move.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How should we handle Nyx\'s message?',
              choices: [
                {
                  text: 'Stay Calm and Strategize',
                  next: {
                    scene: 'countdownBegins',
                    beat: 'hiddenBase'
                  }
                },
                {
                  text: 'Engage in Psychological Warfare',
                  next: {
                    scene: 'countdownBegins',
                    beat: 'psychologicalWarfare'
                  }
                }
              ]
            }
          ]
        },
        psychologicalWarfare: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You won\'t win, Nyx. We will stop you.'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'happy',
              text: 'You can try, Elena. But you\'re too late.'
            },
            {
              type: 'hideCharacter',
              characterId: 'nyx',
              position: 'right'
            }
          ],
          next: {
            scene: 'countdownBegins',
            beat: 'hiddenBase'
          }
        },
        hiddenBase: {
          events: [
            {
              type: 'showLocation',
              locationId: 'asteroidBase'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We need to be quick and quiet. Any noise, and they\'ll have us surrounded.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Everyone stay sharp. This is it.'
            }
          ],
          next: {
            scene: 'unexpectedAlly',
            beat: 'familiarFace'
          }
        }
      }
    },
    unexpectedAlly: {
      beats: {
        familiarFace: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weaponControlRoom'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'surprised',
              text: 'I didn\'t expect this, Zara. But we need all the help we can get.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'I\'m here to make things right, Elena. Let\'s end this.',
              choices: [
                {
                  text: 'Accept Zara\'s Help and Move Forward',
                  next: {
                    scene: 'unexpectedAlly',
                    beat: 'finalPush'
                  }
                },
                {
                  text: 'Reject Zara\'s Help and Stay Distrustful',
                  next: {
                    scene: 'unexpectedAlly',
                    beat: 'rejectHelp'
                  }
                }
              ]
            }
          ]
        },
        rejectHelp: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'I don\'t trust you, Zara. Stay out of my way.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I understand. But you\'re going to need my help to get through this.'
            }
          ],
          next: {
            scene: 'unexpectedAlly',
            beat: 'finalPush'
          }
        },
        finalPush: {
          events: [
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'happy',
              text: 'You think you can defeat me? I\'ve already won.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'We\'re not done yet, Nyx. Not by a long shot.'
            }
          ],
          next: {
            scene: 'showdown',
            beat: 'faceToFace'
          }
        }
      }
    },
    showdown: {
      beats: {
        faceToFace: {
          events: [
            {
              type: 'showLocation',
              locationId: 'nyxQuarters'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 10,
              duration: 1,
              waitUntilFinish: true
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'angry',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'It\'s over, Nyx. You\'ve lost.',
              choices: [
                {
                  text: 'Confront Nyx Aggressively',
                  next: {
                    scene: 'showdown',
                    beat: 'aggressiveConfrontation'
                  }
                },
                {
                  text: 'Confront Nyx with Compassion',
                  next: {
                    scene: 'showdown',
                    beat: 'compassionateConfrontation'
                  }
                }
              ]
            }
          ]
        },
        aggressiveConfrontation: {
          events: [
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'angry',
              text: 'I won\'t go down without a fight, Elena. You\'ll have to kill me first.'
            }
          ],
          next: {
            scene: 'showdown',
            beat: 'finalStrike'
          }
        },
        compassionateConfrontation: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'sad',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'sad',
              text: 'This isn\'t the way, Nyx. You don\'t have to do this.'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'angry',
              text: 'You never understood me, Elena. I was trying to save us all.'
            }
          ],
          next: {
            scene: 'showdown',
            beat: 'finalStrike'
          }
        },
        finalStrike: {
          events: [
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 15,
              duration: 2,
              waitUntilFinish: false
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'angry',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'This ends now, Nyx.'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'happy',
              text: 'We\'ll see about that.'
            },
            {
              type: 'showEffect',
              effect: 'flash',
              color: '#ffffff',
              duration: 1,
              waitUntilFinish: true
            }
          ],
          goToChapter: {
            chapter: 'chapter5'
          }
        }
      }
    }
  }
}
